import { baseApi } from './baseApi';

export const permissionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all roles
    getRoles: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `roles/list?${queryString}` : 'roles/list',
        method: 'GET',
      }),
      providesTags: ['Roles'],
    }),

    // Get single role
    getRole: builder.query({
      query: (roleId) => ({
        url: `roles/get?id=${roleId}`,
        method: 'GET',
      }),
      providesTags: (result, error, roleId) => [{ type: 'Role', id: roleId }],
    }),

    // Create role
    createRole: builder.mutation({
      query: (body) => ({
        url: 'roles/create',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Roles'],
    }),

    // Update role
    updateRole: builder.mutation({
      query: (body) => ({
        url: 'roles/edit',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Role', id: body?.id },
        'Roles',
      ],
    }),

    // Delete role
    deleteRole: builder.mutation({
      query: (roleId) => ({
        url: `roles/delete?id=${roleId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Roles'],
    }),

    // Get permissions for a role
    getPermission: builder.query({
      query: (roleId) => ({
        url: `roles/get?id=${roleId}`,
        method: 'GET',
      }),
      providesTags: (result, error, roleId) => [{ type: 'Permission', id: roleId }],
    }),
  }),
});

export const {
  useGetRolesQuery,
  useGetRoleQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useGetPermissionQuery,
} = permissionsApi;